import React, { useEffect, useState } from "react"
import "./PreviousFollowUpVisit.scss"
import { getAllPreviousFollowUpDetails } from "../../core/services/api"
import PreviousFollowUpAppointment from "./PreviousFollowUpAppointment"


export default function PreviousFollowUpVisit({
  patientDetail,
  appointmentId,
  smartSummaryData,
  signatureJson
}: any) {


  const [allFollowUpDetails, setAllFollowUpDetails] = useState<any>([])
  const patientId = patientDetail?.id ? patientDetail?.id : null;

  //get all previous consultant notes details
  const getPreviousFollowUpDetails = async (pid: string, aid: string) => {
    try {
      const response = await getAllPreviousFollowUpDetails(pid, aid)
      setAllFollowUpDetails(response)
    } catch (error) {
      console.error(error)
    }
  }


  //appintment id is sent as optional request param to exclude data of present consultant note to come in minimalistic display of previous consultant note
  useEffect(() => {
    if (patientId && appointmentId) {
      getPreviousFollowUpDetails(patientId, appointmentId)
    }
  }, [patientId, appointmentId])

  return (
    <>
      {allFollowUpDetails && allFollowUpDetails?.length > 0 && (
        <div className="prev-consultant-main-container">
          <div className="prev-cn-heading">Previous Consultant Notes</div>
          {allFollowUpDetails?.map((each: any, index: any) => {
            return (
              // each previous consultant note to display and print
              <PreviousFollowUpAppointment
                each={each}
                patientDetail={patientDetail}
                smartSummaryData={smartSummaryData}
                signatureJson={signatureJson}
              />
            )
          })}
        </div>
      )}
    </>
  )
}